import { render } from "./ReportPageCover.vue?vue&type=template&id=3936e174&ts=true"
import script from "./ReportPageCover.vue?vue&type=script&lang=ts"
export * from "./ReportPageCover.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__